var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375 847 c-221 -73 -326 -269 -254 -472 l22 -62 -25 -74 c-14 -41-23 -80 -21 -86 6 -17 42 -15 138 6 77 17 82 17 138 -1 72 -22 199 -25 216 -46 7 9 21 5 30 -5 13 -21 16 -79 16 -44 0 -98 8 -136 19 -58 18 -67 19 -123 6-89 -21 -88 -23 -65 42 l20 58 -26 56 c-52 116 -25 240 69 327 77 71 123 87246 87 123 0 169 -16 245 -86 64 -59 88 -108 94 -199 5 -68 8 -75 28 -78 36-5 48 38 33 118 -22 125 -94 215 -218 273 -59 28 -79 32 -167 34 -63 2 -115-2 -140 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687 313 c-16 -15 -4 -42 38 -83 l45 -44 -45 -46 c-47 -48 -56 -74-28 -84 11 -5 31 8 64 40 l48 47 50 -46 c54 -50 61 -53 79 -35 18 18 15 25-35 79 l-46 50 48 49 c41 42 46 51 35 65 -19 23 -30 19 -80 -30 l-46 -45 -4445 c-41 42 -68 54 -83 38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiEmpty);
export default __webpack_public_path__ + "static/media/ai-empty.9962dd1b32d6ac41a957cc651b62510b.svg";
export { ForwardRef as ReactComponent };